document.addEventListener("DOMContentLoaded",function(){
  let sliderFix = document.querySelector("slider-component .product__media-list");
let sliderFixBtns = document.querySelectorAll("slider-component .slider-button");
console.log(sliderFix)
console.log(sliderFixBtns)
let leftBtn = sliderFixBtns[0];
let rightBtn = sliderFixBtns[1];

// Function to check scroll position and update buttons
function updateSliderButtons() {

  let scrollLeft = sliderFix.scrollLeft;
  let scrollWidth = sliderFix.scrollWidth;
  let clientWidth = sliderFix.clientWidth;

  console.log({ scrollLeft, scrollWidth, clientWidth });

  // Check if at the start (left end)
  if (scrollLeft <= 20) {
    leftBtn.classList.add("disabled");
  } else {
    leftBtn.classList.remove("disabled");
  }

  // Check if at the end (right end) with small margin
  if (Math.abs(scrollLeft + clientWidth - scrollWidth) <= 20) {
    rightBtn.classList.add("disabled");
  } else {
    rightBtn.classList.remove("disabled");
  }
}



// Also run once on load in case it's already at start or end
updateSliderButtons();

// Optional: Add click listeners to scroll and update state
sliderFixBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    // Scroll your slider here (if not already handled)
    setTimeout(updateSliderButtons, 700); // slight delay if scroll happens on click
  });
});

let scrollTimeout;

sliderFix.addEventListener("scroll", () => {
  // Clear the previous timeout if scrolling continues
  clearTimeout(scrollTimeout);

  // Set a new timeout to run after scrolling has stopped
  scrollTimeout = setTimeout(() => {
    console.log("User stopped scrolling...");
    updateSliderButtons();
  }, 300); // adjust delay as needed
});


  
})




